import React from 'react'

export default function ReportsStatistic() {
  return (
    <div>
      <h2>Thống kê báo cáo</h2>
    </div>
  )
}
